module.exports = __webpack_public_path__ + "img/shangmensogncan_image_zc.430181de.png";